/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FolderSearchIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Folder Search',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M19.28027,18.22168l-1.97437-1.97437c.43726-.64111.69409-1.41431.69409-2.24731,0-2.20605-1.79395-4-4-4s-4,1.79395-4,4,1.79395,4,4,4c.83203,0,1.60449-.2561,2.24512-.69238l1.97461,1.97461c.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973c.29297-.29297.29297-.76758,0-1.06055ZM11.5,14c0-1.37891,1.12109-2.5,2.5-2.5s2.5,1.12109,2.5,2.5-1.12109,2.5-2.5,2.5-2.5-1.12109-2.5-2.5Z"
      fill="currentColor"
    />
    <path
      d="M16.75,5.02148h-5.96387c-.21777,0-.42383-.09473-.56641-.25879l-1.7041-1.96582c-.42773-.49316-1.04688-.77539-1.7002-.77539h-3.56543c-1.24023,0-2.25,1.00977-2.25,2.25v11c0,.96484.78516,1.75,1.75,1.75h5.42773c.41406,0,.75-.33594.75-.75s-.33594-.75-.75-.75H2.75c-.1377,0-.25-.1123-.25-.25V6.52148h14.25c.41309,0,.75.33691.75.75v2.15137c0,.41406.33594.75.75.75s.75-.33594.75-.75v-2.15137c0-1.24023-1.00977-2.25-2.25-2.25ZM2.5,4.27148c0-.41309.33691-.75.75-.75h3.56543c.21777,0,.42383.09375.56641.25781l1.07666,1.24219H2.5v-.75Z"
      fill="currentColor"
    />
  </svg>`;
};
